/* import __COLOCATED_TEMPLATE__ from './aria-tab-list.hbs'; */
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import Component from '@glimmer/component';
const DEFAULT_CLASS = 'ember-tabs__tab-list';

/**
 * List of all tabs component rendered as `<ul />` .
 *
 * If you specify additional props on the `<AriaTabList />` component they will be forwarded to the rendered `<ul />`.
 *
 * Default CSS class: `ember-tabs__tab-list`
 *
 * @class AriaTabList
 * @public
 */
export default class AriaTabListComponent extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "className", DEFAULT_CLASS);
  }
}